import { HTMLChakraProps, IconButton as ChakraIconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { forwardRef } from '../../system';
import Icon from '../Icons/Icon';

import { sizePropTypes } from './Button';

export const variantPropTypes = ['primary', 'secondary', 'default', 'outline', 'ghost', 'unstyled'];

export interface IconButtonProps extends Omit<HTMLChakraProps<'button'>, 'type'> {
  fillColor?: string;
  iconSize?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  type: string;
  variant?: 'primary' | 'secondary' | 'default' | 'outline' | 'ghost' | 'unstyled';
}

const iconSizeMap = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '24px'
};

const propTypes = {
  fillColor: PropTypes.string,
  iconSize: PropTypes.string,
  size: PropTypes.oneOf(sizePropTypes),
  type: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(variantPropTypes)
};

const defaultProps = {
  size: 'md',
  variant: 'default',
  iconSize: null
};

const IconButton = forwardRef<IconButtonProps, 'button'>(
  (
    { size = 'md', iconSize, fillColor, type, variant = 'default', ...rest }: IconButtonProps,
    ref
  ): React.ReactElement => {
    return (
      <ChakraIconButton
        aria-label={`icon-button-${type}`}
        fill={fillColor}
        icon={<Icon boxSize={iconSize || iconSizeMap[size]} type={type} />}
        ref={ref}
        size={size}
        variant={variant}
        {...rest}
      />
    );
  }
);

IconButton.displayName = 'IconButton';
IconButton.propTypes = propTypes;
IconButton.defaultProps = defaultProps;

export default IconButton;
